import React from "react";
import { Box } from "@mui/material";
import dashboard from "../../assets/landing/dashboard.png";
import Hero from "./sections/Hero";
import Features from "./sections/Features";
import ForParticipants from "./sections/ForParticipants";
import Numbers from "./sections/Numbers";
import Founders from "./sections/Founders";
import About from "./sections/About";
import Contact from "./sections/Contact";
import FadeInSection from "./components/FadeInSection";
import { useLandingResponsive } from "./useLandingResponsive";
import { landingTokens } from "./theme";
import { colors } from "../../utils/constants";

const Landing = () => {
  const { isMobile } = useLandingResponsive();

  return (
    <Box>
      <Hero isMobile={isMobile} />

      <FadeInSection>
        <Features isMobile={isMobile} />
      </FadeInSection>

      <FadeInSection>
        <Box
          sx={{
            backgroundColor: "#F7F9FC",
            padding: isMobile ? "32px 16px" : "64px 16px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="span"
            sx={{
              fontSize: isMobile ? 12 : 14,
              fontWeight: 700,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color: colors.primary,
              marginBottom: "12px",
            }}
          >
            Painel do organizador
          </Box>
          <Box
            component="span"
            sx={{
              fontSize: isMobile ? 20 : 26,
              fontWeight: 700,
              color: "#14213D",
              marginBottom: isMobile ? "24px" : "36px",
              textAlign: "center",
            }}
          >
            Acompanhe cada checkin em tempo real
          </Box>
          <Box
            sx={{
              width: "100%",
              maxWidth: 1200,
              borderRadius: `${landingTokens.radius.card}px`,
              border: "1px solid #E5E9F0",
              boxShadow: landingTokens.shadow,
              overflow: "hidden",
              backgroundColor: colors.white,
            }}
          >
            <img src={dashboard} style={{ width: "100%", display: "block", objectFit: "cover" }} alt="Painel com a lista de checkins de um evento" />
          </Box>
        </Box>
      </FadeInSection>

      <FadeInSection>
        <ForParticipants isMobile={isMobile} />
      </FadeInSection>

      <FadeInSection>
        <Numbers isMobile={isMobile} />
      </FadeInSection>

      <FadeInSection>
        <Founders isMobile={isMobile} />
      </FadeInSection>

      <FadeInSection>
        <About isMobile={isMobile} />
      </FadeInSection>

      <Contact isMobile={isMobile} />
    </Box>
  );
};

export default Landing;
